export default __webpack_public_path__ + "static/media/success.234ab6fb.svg";